import React, {useState, useEffect , useRef} from "react";
import { Link } from "react-router-dom";

import LeftMenuLayout from 'layouts/LeftMenuLayout';

import classNames from 'classnames';
import * as Yup from 'yup';
import {API_ENDPOINT, toast_anim } from 'components/config/Common'
import {Loading , WalletPointsIcon} from "components/custom-icons";

import axios from 'axios';  
import {APP_URL, APP_NAME , IMG_URL , LIMIT , amount_format} from 'components/config/Common'

import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import { toast } from 'react-toastify';
import ScrollPageTop from 'components/ui/ScrollPageTop'
import {Links} from 'routes/PathLink'

import { Pagination, Select } from "antd";
import { Table } from "components/ui/table";
import Button from 'components/ui/Button.tsx'
import DemoPortfolioTable  from "components/DemoPortfolioTable";

/*import {
  useUserScreensQuery, useDeleteScreenMutation,
} from 'data/dashboard-data';
 */
import {
  useDemoPortfolioQuery
} from 'data/company';

import ModalView from '_utils/ModalView'
import Seo from 'components/seo/seo'
import { use } from "i18next";


const MySmartPortfolio = () => {
	
	const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'))

	//const [forums,setForums]= useState([]);
  const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_PAGE_LIMIT);
    const [orderBy, setOrder] = useState('created_at');
    const [sortedBy, setColumn] = useState('desc');
  const [open, setOpen] = useState(false);
  const [screenId, setScreenId] = useState(null);

  useEffect(() => {
    
    // Fetch screens when component mounts or page/pageSize/orderBy/sortedBy changes
  }, [page, pageSize, orderBy, sortedBy]);

	const onPagination = (current) => {
    console.log("current Page",current);
    setPage(current);
  }

  const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }

  
	const {
      demoportfoliodata,
         paginatorInfo,
      isLoading,
      error,
    } = useDemoPortfolioQuery({ 
      limit: pageSize,
      page,    
      orderBy,
      sortedBy,
    });

    const totalPages = Math.ceil(paginatorInfo?.total / pageSize);
    //console.log("Screens Data ",screens)

   // const {mutate: deleteScreenMutation} = useDeleteScreenMutation(screenId);


	const siteMetadata = {
		url: `${APP_URL}/profile`,
		title:  `My wallet - ${APP_NAME}`,
		description: `My wallet - ${APP_NAME}`,
	}
    
   
        
/*const deleteScreen = () => {
  //setOpen(true);
  //console.log("Delete Screen Id ",screenId)
  deleteScreenMutation(screenId, {
    onSuccess: (data) => {
      //console.log("Screen Deleted Successfully ",data);
      setOpen(false);
    toast.success("Screen deleted successfully!", toast_anim);
    },
    onError: (error) => {
      console.log("Error Deleting Screen ",error);
      toast.error("Error deleting screen. Please try again.", toast_anim);
    },
  });
}
  */

const openDeleteModal = (screenId) => {
  setOpen(true);
  setScreenId(screenId);
}
        



	return (
		<ScrollPageTop>
        <Seo 
          title={`My Smart Portfolio - ${APP_NAME}`}
          desc={`My Smart Portfolio - ${APP_NAME}`}
          url={`${APP_URL}/my-smart-portfolio`}
        />
         <LeftMenuLayout> 
				<div className="w-full ">
					<div className={classNames('bg-white w-full shadow rounded mb-8')}>
						{/*<p className="text-lg lg:text-xl text-heading capitalize mb-5 dark:text-zinc-400">Welcome You are logged In.</p>*/}
						
						<h2 className="text-2xl font-semibold p-8">My Smart Portfolio</h2>
                <DemoPortfolioTable 
                      data={demoportfoliodata} 
                      pageSize={pageSize} 
                      isLoading={isLoading} 
                      paginatorInfo={paginatorInfo}
                      totalPages={totalPages}
                      onPagination={onPagination}
                      onPageSize={onPageSize}
                  />
					</div>
				</div>
		</LeftMenuLayout> 
    <ModalView open={open} onClose={() => setOpen(false)}>
        <div className="flex flex-col justify-center p-6">
            <h2 className="text-2xl font-semibold mb-4">Delete Screen</h2>
            <p className="mb-6">Are you sure you want to delete this screen? This action cannot be undone.</p>
            <div className="flex justify-end space-x-4">
                <Button size="small" variant="outline"  onClick={() => setOpen(false)}>Cancel</Button>
               {/* <Button size="small" className="bg-red-500 text-white hover:bg-red-600" onClick={() => deleteScreen()}>Delete</Button> */}
            </div>
        </div>                     
    </ModalView>
      </ScrollPageTop>
   );
};

export default MySmartPortfolio;